export function objectToQueryParam (value: any) {
  return btoa(encodeURIComponent(JSON.stringify(value)))
}

export function queryParamToObject (value: string) {
  return JSON.parse(decodeURIComponent(atob(value)))
}
